import type {
  DeveloperDetails,
  TargetableModel,
} from '@cotera/client/v0/actions/framework';

export type WorkflowRunDeveloperDetails = {
  orgId: string;
  runId: string;
  workflowId: string;
  triggerId: string;
  retryOf: string | null;
  retryNum: number;
};

/**
 * Lightweight model placed in scope while a workflow run is open. Targeting is
 * unused but required by {@link TargetableModel}.
 */
export class WorkflowRunDetailModel implements TargetableModel {
  readonly id: string;
  isTargeted = false;

  constructor(readonly details: WorkflowRunDeveloperDetails) {
    this.id = details.runId;
  }

  target(): void {
    this.isTargeted = true;
  }

  markAsNotTargeted(): void {
    this.isTargeted = false;
  }

  developerDetails(): DeveloperDetails {
    const { orgId, runId, workflowId, triggerId, retryOf, retryNum } =
      this.details;
    const entries = [
      { key: 'Org ID', value: orgId },
      { key: 'Run ID', value: runId },
      { key: 'Workflow ID', value: workflowId },
      { key: 'Trigger ID', value: triggerId },
    ];

    if (retryOf !== null) {
      entries.push({ key: 'Retry of', value: retryOf });
      entries.push({ key: 'Attempt', value: String(retryNum + 1) });
    }

    return {
      title: 'Workflow run',
      entries,
    };
  }
}
